import React from 'react'
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

import { ReactComponent as UserManualIcoSvg } from '~/assets/images/icons/user-manual.svg'

export function UserManualIcon(props: SvgIconProps): JSX.Element {
	return (
		<>
			<SvgIcon {...props}>
				<UserManualIcoSvg />
			</SvgIcon>
		</>
	)
}
